



















































































import {Component, Emit, Prop} from "vue-property-decorator";
import abpbase from "../../lib/abpbase";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import {paginationElement, recordElement} from "@/api/typeDefined";
import WordCloudChart from "@/components/wordCloudChart.vue";
import AppConsts from "@/lib/appconst";

@Component({
    name: 'queryTabList',
    components: {WordCloudChart},
    filters: {
        imgUrlFilter(url: string = '') {
            if (url&&url.indexOf('http') > -1) {
                return url;
            } else {
                let fileResourceUrl: string = AppConsts.fileResourceUrl;
                return `${fileResourceUrl}${url}`;
            }
        }
    }
})
export default class queryTabList extends abpbase {
    //关键字
    keywords: string;
    //是否显示
    visible: boolean = false;
    //所有数据
    allRecords: recordElement[] = [];

    moduleType: string = '';//  模块: 1: 知识库; 2: Q&A; 空: 全部

    //分页
    pagination: paginationElement = {
        ...AppConsts.pagination,
        onShowSizeChange: (pageIndex, size) => {
            this.pagination.current = pageIndex;
            this.pagination.pageSize = size;
            this.fetchRecords();
        },
        onChange: pageIndex => {
            this.pagination.current = pageIndex;
            this.fetchRecords();
        }
    };

    //初始化分页参数
    initPagination() {
        this.pagination = {
            ...AppConsts.pagination,
            onShowSizeChange: (pageIndex, size) => {
                this.pagination.current = pageIndex;
                this.pagination.pageSize = size;
                this.fetchRecords();
            },
            onChange: pageIndex => {
                this.pagination.current = pageIndex;
                this.fetchRecords();
            }
        };
    }

    //获取所有的记录(moduleType  模块: 1: 知识库; 2: Q&A; 空: 全部)
    fetchRecords() {
        let {current, pageSize} = this.pagination;
        const queryParams = {
            currentPage: current,
            pageSize: pageSize,
            moduleType: this.moduleType,
            keyWords: this.keywords
        };

        ajaxHelperInstance.get('/web/global/query', queryParams, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                this.allRecords = data.data || [];
                this.pagination.total = 0;
                if (data) {
                    let {page} = data;
                    if (page) {
                        this.pagination.total = page.total;
                    }
                }
            }
        });
    }

    //显示（初始化）
    show(moduleType: string = '', keywords: string = '') {
        //显示
        this.visible = true;
        this.keywords = keywords;
        this.moduleType = moduleType;
        this.initPagination();
        this.fetchRecords();
    }

    //隐藏
    hide() {
        this.visible = false;
    }

    //显示详情
    // @Emit('showDetail')
    handleShowDetail(item: any) {
        let {moduleType, docId} = item;
        if (docId && moduleType) {
            let routerName = 'knowledgeBaseDetail';
            let params: any = {queryParams: JSON.stringify({docId: docId, keywords: this.keywords})};
            if (moduleType == '2') {
                routerName = 'QADetail';
                params = {
                    queryParams: JSON.stringify({
                        questionId: docId,
                        skipPath: {
                            path: 'query',
                            breadcrumbName: '搜索'
                        }
                    })
                };
            }
            this.switchRouting(routerName, params);
        }
    }
}
